var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:{
  'text-red': _vm.transaction.senderId === _vm.$route.params.address,
  'text-green': _vm.transaction.recipientId === _vm.$route.params.address && !_vm.isSpecialType,
}},[_vm._v(_vm._s(_vm.readableCrypto(_vm.transaction.amount)))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9a3fc486","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/TransactionAmount.vue
// module id = null
// module chunks = 